// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2019-01-25T10:28:37Z                      #

// ##############################################################

export function updateAdresa_CEF31D(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'AdresaVO',
    };


    return result;
}

export function updateMapAdresa_CEF31D(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateAdresa_CEF31D(data[key]);
    });
    return result;
}

export function updateListAdresa_CEF31D(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateAdresa_CEF31D);
}

export function updateFindAdresyParams_6B6AAA(data) {
    if (data == null) {
        return data;
    }
    let result = {
        ...data,
        '@class': data['@class'] ? data['@class'] : 'FindAdresyParamsVO',
    };


    return result;
}

export function updateMapFindAdresyParams_6B6AAA(data) {
    if (data == null) {
        return data;
    }
    const result = {};
    Object.keys(data).forEach(key => {
        result[key] = updateFindAdresyParams_6B6AAA(data[key]);
    });
    return result;
}

export function updateListFindAdresyParams_6B6AAA(data) {
    if (data == null) {
        return data;
    }
    return data.map(updateFindAdresyParams_6B6AAA);
}
